module.exports = __webpack_public_path__ + "img/gold.0e5e8709.png";